import { Box } from '@chakra-ui/react';
import { TodoListProps } from '../types';
import TodoItem from './TodoItem';

function TodoList({ todos }: TodoListProps) {
  return (
    <Box>
      {todos.map(todo => (
        <TodoItem key={todo.id} todo={todo} mb={4} />
      ))}
    </Box>
  );
}

export default TodoList;
